"use client";

import { MinusIcon, PlusIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QuantityCounterProps {
  quantity: number;
  setQuantity: (quantity: number) => void;
  minQuantity?: number;
  maxQuantity?: number;
}

export function QuantityCounter({
  quantity,
  setQuantity,
  minQuantity = 1,
  maxQuantity = Infinity,
}: QuantityCounterProps) {
  const canDecrement = quantity > minQuantity;
  const canIncrement = quantity < maxQuantity;

  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8"
        disabled={!canDecrement}
        onClick={() => setQuantity(Math.max(minQuantity, quantity - 1))}
        aria-label="Zmniejsz ilość"
      >
        <MinusIcon className="h-3 w-3" />
      </Button>
      <span className="w-8 text-center text-sm font-semibold tabular-nums">
        {quantity}
      </span>
      <Button
        type="button"
        variant="outline"
        size="icon"
        className="h-8 w-8"
        disabled={!canIncrement}
        onClick={() => setQuantity(Math.min(maxQuantity, quantity + 1))}
        aria-label="Zwiększ ilość"
      >
        <PlusIcon className="h-3 w-3" />
      </Button>
    </div>
  );
}
